import { AbstractDocumentsFacade } from '@pf/shared-services';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    IDocument,
    IDocumentCreate,
    IDocumentSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { ShipmentFilesService } from '@control-tower/platform-wms';

@Injectable({ providedIn: 'root' })
export class ShipmentDocumentsFacade extends AbstractDocumentsFacade {
    constructor() {
        const dataService = inject(ShipmentFilesService);

        super(PFWmsEntities.Shipment, {
            create$: (entityId: string, document: IDocumentCreate) =>
                dataService.shipmentFilePost({
                    shipmentId: entityId,
                    ...document,
                }) as Observable<IDocument>,
            delete$: (entityId: string, documentId: string) =>
                dataService.shipmentFileDelete({
                    id: documentId,
                    shipmentId: entityId,
                }) as Observable<IDocument>,
            get$: (entityId: string, documentId: string) =>
                dataService.shipmentFileReadById({
                    id: documentId,
                    shipmentId: entityId,
                }) as Observable<IDocument>,
            search$: (entityId: string, params: IDocumentSearchParams) =>
                dataService.shipmentFileSearch({
                    shipmentId: entityId,
                    ...params,
                }) as Observable<IPagedResult<IDocument>>,
            download$: (entityId: string, documentId: string) => {
                return dataService.shipmentFileGet({
                    id: documentId,
                    shipmentId: entityId,
                });
            },
        });
    }
}
